import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { BackgroundMaskCover } from "./BackgroundMaskCover";
export var BackgroundMask = /*#__PURE__*/function () {
  function BackgroundMask() {
    _classCallCheck(this, BackgroundMask);
    this.composite = "destination-out";
    this.cover = new BackgroundMaskCover();
    this.enable = false;
  }
  _createClass(BackgroundMask, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.composite !== undefined) {
        this.composite = data.composite;
      }
      if (data.cover !== undefined) {
        var cover = data.cover;
        var color = typeof data.cover === "string" ? {
          color: data.cover
        } : data.cover;
        this.cover.load(cover.color !== undefined ? cover : {
          color: color
        });
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
    }
  }]);
  return BackgroundMask;
}();